var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrandTelegram = function SvgBrandTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 27 27",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.031 3.668a.834.834 0 0 1 1.11.979l-4.444 17.777a.833.833 0 0 1-1.398.388l-4.876-4.877-2.757 3.677a.833.833 0 0 1-1.458-.237l-2.113-6.34-4.135-2.067a.834.834 0 0 1 .071-1.522zM5.386 12.317l2.763 1.382a.84.84 0 0 1 .42.482l1.718 5.157 1.945-2.593-.6-.6a.833.833 0 0 1 0-1.178l4.445-4.445a.833.833 0 1 1 1.178 1.178L13.4 15.557l5.037 5.037 3.697-14.789z"
  })));
};
export default SvgBrandTelegram;